import { Address } from 'src/models/Address';

export class AddressDTO {
  public addressLine01!: string;
  public addressLine02?: string;
  public addressLine03?: string;
  public city!: string;
  public countryCode!: string;
  public countryName!: string;
  public countryNameEnglish!: string;
  public longitude?: string;
  public latitude?: string;
  public zip!: string;

  constructor(model: Address) {
    this.addressLine01 = model.street;
    this.zip = model.zip;
    this.city = model.city;
    this.countryCode = model.countryCode;
  }
}
